





































































































































































































import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsuhanKeperawatanGawatDarurat from "@/services/AsuhanKeperawatanGawatDarurat";
import { appModule } from "@/store/modules/app";
import AskepGadarInputModal from "@/components/AskepGadar/AskepGadarInputModal.vue";
import { userModule } from "@/store/modules/user";
import PerencanaanTable from "@/components/pemeriksaan/PerencanaanTable.vue";
import ImplementasiTable from "@/components/pemeriksaan/ImplementasiTable.vue";
import RencanaAskepSvc from "@/services/RencanaAskep";
import ImplementasiAskepSvc from "@/services/ImplementasiAskep";
import { bandingRencana } from "@/utils/askepRencana";

interface AsuhanItem {
  id: number;
  diagnosis: {
    id: number;
    name: string;
  };
  tujuan: [
    {
      id: number;
      name: string;
    }
  ];
  rencana: [
    {
      id: number;
      name: string;
    }
  ];
  implementasi: [
    {
      id: number;
      name: string;
      time?: string | number;
    }
  ];
  creator: {
    id: number;
    nama: string;
  };
  examinedAt: any;
}

@Component({
  components: {
    PerawatAutoComplete,
    AskepGadarInputModal,
    PerencanaanTable,
    ImplementasiTable
  }
})
export default class AsuhanKeperawatanGawatDaruratCard extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  loading = false;

  asuhanList: AsuhanItem[] = [];
  showInputModal = false;
  editedItem = null;

  planning: any[] = [];
  implementationList: any[] = [];
  loadingPlanning = false;
  loadingImplementation = false;

  // urutan sama dengan menu Asuhan Keperawatan: aktif dulu (by seq), stopped di bawah
  get planningList() {
    return this.planning.slice().sort(bandingRencana);
  }

  get renderedAsuhanList() {
    return this.asuhanList.slice().sort((a, b) => {
      return (
        new Date(a.examinedAt).getTime() - new Date(b.examinedAt).getTime()
      );
    });
  }

  mounted() {
    this.getByRegister();
    this.loadAskepBaru();
  }

  async loadAskepBaru() {
    if (!this.register) return;

    this.loadingPlanning = true;
    this.loadingImplementation = true;

    try {
      const [rencana, implementasi] = await Promise.all([
        RencanaAskepSvc.getByRegister(this.register),
        ImplementasiAskepSvc.getByRegister(this.register)
      ]);

      this.planning = rencana.data || [];
      this.implementationList = (implementasi.data || [])
        .slice()
        .sort(
          (a, b) =>
            new Date(b.authored_at).getTime() -
            new Date(a.authored_at).getTime()
        );
    } catch (error) {
      console.error("Error loading askep (rencana/implementasi):", error);
    } finally {
      this.loadingPlanning = false;
      this.loadingImplementation = false;
    }
  }

  async getByRegister() {
    let list = [];

    this.loading = true;

    await AsuhanKeperawatanGawatDarurat.getByRegister(this.register).then(
      function(response) {
        list = response.data.map(item => {
          return {
            id: item.id,
            diagnosis: item.content.diagnosis,
            tujuan: item.content.tujuan,
            rencana: item.content.rencana,
            implementasi: item.content.implementasi,
            creator: item.content.perawat,
            examinedAt: item.content.examinedAt
          };
        });
      }
    );

    this.asuhanList = list;
    this.loading = false;
  }

  edit(item: AsuhanItem) {
    const canModify = this.checkIsUserCanModifyRecord(
      item,
      `Tidak bisa mengubah/edit asuhan yang sudah ditulis oleh ${item.creator.nama}`
    );

    if (canModify) {
      this.editedItem = item;

      this.showInputModal = true;
    }
  }

  checkIsUserCanModifyRecord(record: AsuhanItem, message: string): boolean {
    if (userModule.user.id != record.creator.id) {
      appModule.sendErrorAlert(message);

      return false;
    }

    return true;
  }

  @Watch("showInputModal")
  changedShowInputModal(val) {
    if (!val) {
      this.editedItem = null;
    }
  }

  remove(item: AsuhanItem) {
    const canModify = this.checkIsUserCanModifyRecord(
      item,
      `Tidak bisa menghapus asuhan yang sudah ditulis oleh ${item.creator.nama}`
    );

    if (canModify) {
      const q = confirm("Hapus Asuhan Keperawatan ini?");

      if (q) {
        AsuhanKeperawatanGawatDarurat.destroy(item.id).then(() => {
          appModule.NoticeDelay("Berhasil Hapus Asuhan Keperawatan");

          this.getByRegister();
        });
      }
    }
  }

  print() {
    AsuhanKeperawatanGawatDarurat.print(this.register);
  }
}
